import React, { Component } from 'react';
import axios from 'axios';
import config from '../config'

class ForgotPassword extends Component {
  constructor() {
    super();
    this.state = {    
        email: '',
        error: false,
        success: false,       
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.backToLogin=this.backToLogin.bind(this);
  }

  backToLogin() {
    let redirectUrl = "";
    config.REDIRECT_URL.forEach(element => {
      if (window.location.origin.indexOf(element.domainId)!=-1) {
        // redirectUrl = window.location.origin + "/security/login?redirectURL=" + window.location.origin + element.redirectUrl;
        redirectUrl = window.location.origin + "/security/login" + window.location.search;
      }
    });
    if (redirectUrl) {
      window.location = redirectUrl;
    }
  }

  handleSubmit(event){
    event.preventDefault();
        if (!event.target.checkValidity()) {
            this.setState({
            error: true,
          });
          return;
        }
        this.setState({
          error: false,
        });

        let datatoken = window.location.origin;
        let data = {};
        data.email = this.state.email;
        data.domain = datatoken;
        data.subDomain = window.location.search;
        
                       // make API call here
        // make the uri dynamic
        // change to axios        
        let _API_URI = config.API_BASE_URL + config.API_RESETPASSWORD;
        let _method = 'POST';
        let _headers = {
            "Content-Type": "application/json"
          }
        axios({
            url: _API_URI,
            method: _method,
            data: JSON.stringify(data),
            headers: _headers,
        })
      .then(response => {            
          if (response.status === 200) {
              //  handle success                                         
              this.setState({
                  error: false,
                  success: true,
                  message: response.data.message,
              });
          } else {
            throw new Error(response.statusText);
          }
        })
      .catch(error => {
          //  handle error
          this.setState({
              error: true,
              success: false,
              message: error.response.data.message,              
              email: '',
          });          
      });
  }
  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;        
    this.setState({
      [name]: value
    });
  }
    render() {
      const {email, error, message, success} = this.state;
        return (
            <div className="container">
            <div className="card card-login mx-auto mt-5">
              <div className="login-logo" > </div>
              <div className="login-header text-center">Reset Password</div>
              <div className="card-body pt-2">
              {error &&
                        <div className="alert alert-danger">
                            <strong></strong>{ message }
                        </div>
              }
              {success && 
                    <div>
                        <div className="text-center mb-4">                            
                            <p className="justify">If that email address is in our database, we will send you an email to reset your password. Kindly check your authorized registered email for further details.</p>
                        </div>
                        <div className="text-center">
                            <a className="d-block small mt-3 pointer" onClick={this.backToLogin}>Login</a>                            
                        </div>
                    </div>
                }
                {!success &&
                <div>
                <div className="text-center mb-4">
                  {/*<h5 className="lightgray">Forgot your password?</h5>*/}
                  {/* <p className="lightgray">Enter your email address and we will send you instructions on how to reset your password.</p> */}
                </div>
                <form onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    {/*<div className="form-label-group">*/}
                      <input  type="email" 
                              id="email" 
                              name="email" 
                              className="form-control custom-input" 
                              placeholder="Email address *" 
                              required="required" 
                              value={email}
                              onChange={this.handleInputChange}
                              maxLength="50"
                              autoComplete = "off"/>  
                    {/*</div>*/}
                  </div>                  
                  <button className="btn btn-primary btn-block" type="submit">Reset Password</button>
                </form>
                {/*<div className="text-center mt-2">
                  <a className="small mt-3" href="/pnc/auth/register">Register an Account</a>
                </div>*/}
                <div className="text-center">                  
                  <a className="small pointer bluefont" onClick={this.backToLogin}>Login</a>   
                </div>
                </div>
              }
              </div>  
              <div className="login-footer"> © 2024 Reliance Industries Limited. All rights reserved.</div>            
            </div>
          </div>
        );
    }
}

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js